import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../../shared/services/data-storage.service';
import {Subscription} from 'rxjs';
import {UserLogin} from '../../../shared/models/user.model';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {Upload} from '../../../shared/models/upload.model';
import {UploadService} from '../../../shared/services/upload.service';

@Component({
    selector: 'form-edit-upload',
    templateUrl: 'form-edit-upload.html'
})
export class FormEditUploadComponent implements OnInit, OnDestroy {

    @Input() uploads: Upload[];
    @Input() reservation_id: number;

    is_add = false;

    private userSub: Subscription;
    user: UserLogin;

    constructor(private dataStorageService: DataStorageService
        , private authenticationService: AuthenticationService
        , private uploadService: UploadService) {
    }

    ngOnInit() {
        this.userSub = this.authenticationService.user.subscribe(user => {
            this.user = user;
        });
    }

    onToggleUpload() {
        this.is_add = !this.is_add;
    }

    onUpload() {
        this.uploadService.uploadProcessEmitter.emit({'type': 'reservation', id: this.reservation_id});
    }

    onDeleteUpload(id: number, name: string) {
        this.dataStorageService.deleteUpload(id, name).subscribe(
            (responseData) => {
                if (responseData['status'] === '200') {
                    location.reload();
                } else if (responseData['status'] === '405') {
                    alert(responseData['error']);
                }
            }
        );
    }

    ngOnDestroy() {
        this.userSub.unsubscribe();
    }

}
